import type { CSSProperties } from 'react';
import type { ChannelCloseoutListItem } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { closeoutStatusLabel, formatCloseoutDateRange } from './channelCloseoutPresentation';

const TONE: Record<ChannelCloseoutListItem['syncStatus'], string> = {
  Synced: 'bg-navy text-white',
  Failed: 'border-sealwax text-sealwax bg-card border-2 border-dashed',
  Pending: 'border-amber-ink bg-amber-tint text-amber-ink border-2 border-dashed',
  NeedsReconcile: 'border-amber-ink bg-amber-tint text-amber-ink border-2 border-dashed',
  Drifted: 'border-amber-ink bg-amber-tint text-amber-ink border-2 border-dashed',
};

/** Ein Balken der Zeitleiste; ohne `onSelect` reine Anzeige mit Tooltip. */
export function ChannelCloseoutTimelineBar({
  rule,
  showName,
  onSelect,
  style,
}: {
  rule: ChannelCloseoutListItem;
  showName: boolean;
  onSelect: (() => void) | undefined;
  style: CSSProperties;
}) {
  const apartments = rule.apartments.map((item) => item.name).join(', ');
  const removing = rule.desiredState === 'Deleted';
  const title =
    `${rule.name}, ${formatCloseoutDateRange(rule.startDate, rule.endDate)}, ${apartments}, ` +
    `${closeoutStatusLabel(rule.syncStatus)}${removing ? ', wird aufgehoben' : ''}`;
  const className = cn(
    'absolute truncate rounded-md px-2 text-left text-[11px] font-bold leading-[18px]',
    TONE[rule.syncStatus],
    removing && 'line-through opacity-60',
  );
  if (!onSelect) {
    return (
      <span title={title} className={className} style={style}>
        {showName && rule.name}
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={onSelect}
      title={title}
      aria-label={title}
      className={cn(
        className,
        'focus-visible:ring-forest/50 focus-visible:outline-none focus-visible:ring-2',
      )}
      style={style}
    >
      {showName && rule.name}
    </button>
  );
}
